// Dynamic Shopify Rewards Customization Script
function customizeRewardsDisplay() {
  // Find the rewards container
  const rewardsContainer = document.getElementById('rewards');
  const messageElement = document.querySelector('.message');
  const progressElement = document.querySelector('.progress');
  
  if (!rewardsContainer || !messageElement) {
    console.log('Required elements not found');
    return;
  }
  
  // Get all rewards
  const allRewards = rewardsContainer.querySelectorAll('.reward');
  const achievedRewards = rewardsContainer.querySelectorAll('.reward.achieved');
  
  // Extract progress bar colors if available (kept for potential future use)
  let progressColors = { primary: null };
  if (progressElement) {
    progressColors = extractProgressColors(progressElement);
  }
  
  // Override CSS styling for achieved rewards
  achievedRewards.forEach(reward => {
    const rewardText = reward.querySelector('.reward-text');
    if (rewardText) {
      // Apply custom styling to override CSS
      rewardText.style.color = '#666';
      rewardText.style.fontWeight = 'normal';
      console.log(`Applied custom styling to achieved reward: ${rewardText.textContent}`);
    }
  });
  
  // Reset styling for non-achieved rewards (remove any previous overrides)
  const nonAchievedRewards = rewardsContainer.querySelectorAll('.reward:not(.achieved)');
  nonAchievedRewards.forEach(reward => {
    const rewardText = reward.querySelector('.reward-text');
    if (rewardText) {
      rewardText.style.color = '';
      rewardText.style.fontWeight = '';
    }
  });
  
  // Handle congratulations message customization
  if (achievedRewards.length > 0 && 
      messageElement.textContent === "Congratulations! You've earned all rewards!") {
    
    if (achievedRewards.length === 1) {
      // Single reward - customize message
      const reward = achievedRewards[0];
      const rewardText = reward.querySelector('.reward-text');
      
      if (rewardText) {
        const customMessage = createCustomMessage(rewardText.textContent);
        if (customMessage) {
          messageElement.textContent = customMessage;
          console.log(`Updated message to: ${customMessage}`);
        }
      }
    } else {
      // Multiple rewards - show message for the highest/latest target
      const highestReward = getHighestTargetReward(achievedRewards);
      if (highestReward) {
        const rewardText = highestReward.querySelector('.reward-text');
        if (rewardText) {
          const customMessage = createCustomMessage(rewardText.textContent);
          if (customMessage) {
            messageElement.textContent = customMessage;
            console.log(`Updated message to latest target: ${customMessage}`);
          }
        }
      }
    }
  }
}

// Get the reward with the highest target value
function getHighestTargetReward(rewards) {
  let highestReward = null;
  let highestTarget = 0;
  
  rewards.forEach(reward => {
    const targetValue = parseFloat(reward.getAttribute('data-target')) || 0;
    if (targetValue > highestTarget) {
      highestTarget = targetValue;
      highestReward = reward;
    }
  });
  
  console.log(`Highest target reward found: ${highestTarget}`);
  return highestReward;
}

// Extract colors from progress bar gradient
function extractProgressColors(progressElement) {
  const style = progressElement.style.background || progressElement.style.backgroundImage;
  const colors = { primary: null, secondary: null };
  
  // Try to extract RGB values from linear-gradient
  const rgbMatches = style.match(/rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/g);
  
  if (rgbMatches && rgbMatches.length > 0) {
    colors.primary = rgbMatches[0]; // First color in gradient
    if (rgbMatches.length > 1) {
      colors.secondary = rgbMatches[1]; // Second color in gradient
    }
  } else {
    // Fallback: try to extract from computed styles
    const computedStyle = window.getComputedStyle(progressElement);
    const backgroundImage = computedStyle.backgroundImage;
    
    if (backgroundImage && backgroundImage !== 'none') {
      const fallbackMatches = backgroundImage.match(/rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/g);
      if (fallbackMatches && fallbackMatches.length > 0) {
        colors.primary = fallbackMatches[0];
      }
    }
  }
  
  console.log('Extracted colors:', colors);
  return colors;
}

// Create custom message based on reward text
function createCustomMessage(rewardText) {
  if (!rewardText) return null;
  
  // Split text at "at" to get the reward name
  const parts = rewardText.toLowerCase().split(' at ');
  if (parts.length >= 2) {
    const rewardName = parts[0].trim();
    
    // Create appropriate message based on reward type
    if (rewardName.includes('free shipping')) {
      return "You've earned free shipping!";
    } else if (rewardName.includes('free gift')) {
      return "You've earned a free gift!";
    } else if (rewardName.includes('discount')) {
      return `You've earned a ${rewardName}!`;
    } else if (rewardName.includes('off')) {
      return `You've earned ${rewardName}!`;
    } else if (rewardName.includes('free')) {
      // Generic free item
      const item = rewardName.replace('free', '').trim();
      return `You've earned a free ${item}!`;
    } else {
      // Generic reward
      return `You've earned ${rewardName}!`;
    }
  }
  
  return null;
}

// Function to observe DOM changes and apply customizations
function setupRewardsObserver() {
  // Run initially
  customizeRewardsDisplay();
  
  // Set up a MutationObserver to watch for changes in the entire document
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      // Check if nodes were added or if text content changed
      if (mutation.type === 'childList' || mutation.type === 'characterData') {
        customizeRewardsDisplay();
      }
    });
  });
  
  // Start observing the entire document body for changes (to catch cart drawer)
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });
  console.log('Rewards observer set up successfully for entire document');
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupRewardsObserver);
} else {
  setupRewardsObserver();
}

// Also run after delays to catch any dynamically loaded content
setTimeout(customizeRewardsDisplay, 1000);
setTimeout(customizeRewardsDisplay, 3000);

// Additional event listeners for cart drawer interactions
document.addEventListener('click', function(event) {
  // If cart icon is clicked, wait for drawer to load then customize
  if (event.target.closest('#cart-icon-bubble') || event.target.closest('.header__icon--cart')) {
    setTimeout(customizeRewardsDisplay, 500);
    setTimeout(customizeRewardsDisplay, 1500);
  }
});

// Listen for cart updates (when items are added/removed)
document.addEventListener('cart:updated', function() {
  setTimeout(customizeRewardsDisplay, 500);
});

// Alternative cart events that some themes use
document.addEventListener('cart:refresh', function() {
  setTimeout(customizeRewardsDisplay, 500);
});

document.addEventListener('cartDrawer:open', function() {
  setTimeout(customizeRewardsDisplay, 500);
});